




import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import AdminLayout from "./layouts/AdminLayout";
import Home from "./page/client/Home";
// import About2 from "./page/client/About2";
import About from "./page/client/About";
import Login from "./page/login";
import Dashboard from "./page/admin/Dashboard";
import Posts from "./page/admin/Posts";
import Users from "./page/admin/Users";
import NotFound from "./page/NotFound";
import UnderConstruction from "./page/UnderConstruction";
import Partners from "./page/admin/Partners";
import { ToastContainer } from "react-toastify";
import Contact from "./page/client/Contact";
import DetailPost from "./page/client/DetailPost";
import { useSelector, useDispatch } from "react-redux";
import { fetchPartners } from "./features/admin/PartnerSlice";
import {
  fetchPublicPosts,
  fetchNotifications,
  fetchPosts,
} from "./features/admin/PostsSlice";
import LoadingScreen from "./components/client/Loading";
import Roles from "./page/admin/Roles";
import ProductDetailPage from "./page/client/ProductDetail";
import Medias from "./page/admin/Medias";
import Category from "./page/admin/Category";
import PermissionCategoty from "./page/admin/PermissionCategory";
import Products from "./page/admin/Products";
import VideoGallery from "./page/client/Video";
import ProductList from "./page/client/ProductList";
import Video from "./page/admin/Video";
import PublicMembershipDisplay from "./page/client/PublicMembershipDisplay";
import MemberDetailView from "./page/client/MemberDetailView";
import { fetchCategoryByTypePublic } from "./features/admin/CategorySlice";
import News from "./page/client/News";
import NotificationClient from "./page/client/Notification";
import Activities from "./page/client/Activities";
import ShoppingCart from "./page/client/Cart";
import { fetchUsersPublic } from "./features/admin/UserSlice";
import ButtonCart from "./components/ButtonCart";
import Orders from "./page/admin/Orders";
import Coupons from "./page/admin/Coupons";
import OrdersHistory from "./page/admin/OrdersHistory";
import Notification from "./page/admin/Notification";
import Criteria from "./page/admin/Criteria";
import DetailNoti from "./page/client/DetailNoti";
import Registration from "./page/admin/Registration";
import Feedback from "./page/admin/Feedback";
import PointLog from "./page/admin/PointLog";
import AdminContact from "./page/admin/Contact";
import ToastNotification from "./components/ToastNotification";
import ChangePassword from "./page/admin/ChangePassword";
import MembershipFees from "./page/admin/MembershipFees";
import SystemSettings from "./page/admin/SystemSettings";
import AdminSponsors from "./page/admin/Sponsors";
import AuditLogs from "./page/admin/AuditLogs";
import Sponsors from "./page/client/Sponsors";
import SponsorDetail from "./page/client/SponsorDetail";
import AuthCallback from "./page/client/AuthCallback";
import "suneditor/dist/css/suneditor.min.css";

const getUserPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions
    ? JSON.parse(permissions)?.map((p) => p.permissionSlug)
    : [];
};
const DataLoader = ({ children }) => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const { status: partnerStatus } = useSelector((state) => state.partners);
  const { status: postsStatus } = useSelector((state) => state.posts);
  const { authPostStatus, authNotificationStatus } = useSelector(
    (state) => state.posts,
  );

  useEffect(() => {
    const loadData = async () => {
      if (partnerStatus === "idle") {
        dispatch(fetchPartners());
        dispatch(fetchCategoryByTypePublic("navbar,notification"));
        dispatch(fetchUsersPublic());
      }
      if (postsStatus === "idle") {
        dispatch(fetchCategoryByTypePublic("navbar,notification"));
        await dispatch(fetchPublicPosts());
      }
      if (userId && authPostStatus === "idle") {
        dispatch(fetchPosts());
      }
      if (userId && authNotificationStatus === "idle") {
        dispatch(fetchNotifications());
      }
    };

    loadData();
  }, [dispatch, partnerStatus, postsStatus]);

  if (partnerStatus === "loading" || postsStatus === "loading") {
    return <LoadingScreen />;
  }

  if (partnerStatus === "failed" || postsStatus === "failed") {
    return <div>Error loading data</div>;
  }

  if (partnerStatus === "succeeded" && postsStatus === "succeeded") {
    return children;
  }

  return null;
};

const hasPermission = (requiredPermission) => {
  const userId = localStorage.getItem("userId");
  if (userId == 1) {
    return true;
  }
  const userPermissions = getUserPermissions();
  return userPermissions.includes(requiredPermission);
};
function App() {
  const isAuthenticated = () => {
    return localStorage.getItem("access_token_bccu");
    //  &&
    // localStorage.getItem("type_user") === "admin"
  };

  const userId = localStorage.getItem("userId");
  const isAdminRoute =
    window.location.pathname.startsWith("/admin") ||
    window.location.pathname.startsWith("/login") ||
    !userId;

  return (
    <Router>
      <DataLoader>
        <ToastContainer autoClose={1000} />
        <ToastNotification />
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/gioi-thieu" element={<About />} />
            <Route path="/lien-he" element={<Contact />} />
            <Route path="/post/:slug" element={<DetailPost />} />
            <Route path="/san-pham/:slug" element={<ProductDetailPage />} />
            <Route path="/video" element={<VideoGallery />} />
            <Route path="/nha-tai-tro" element={<Sponsors />} />
            <Route path="/nha-tai-tro/:id" element={<SponsorDetail />} />
            <Route path="/danh-sach-san-pham" element={<ProductList />} />
            <Route path="/tin-tuc-su-kien" element={<News />} />
            <Route path="/hoat-dong" element={<Activities />} />
            <Route path="/hoat-dong/:slug" element={<News />} />
            <Route path="/thong-bao/:slug" element={<NotificationClient />} />
            <Route path="/thong-bao/:slug/:slug1" element={<DetailNoti />} />
            <Route
              path="/danh-sach-hoi-vien/:slug"
              element={<PublicMembershipDisplay />}
            />
            <Route
              path="/danh-sach-hoi-vien"
              element={<PublicMembershipDisplay />}
            />
            <Route path="/thanh-vien/:slug" element={<MemberDetailView />} />
            <Route path="/gio-hang" element={<ShoppingCart />} />
          </Route>
          <Route
            path="/admin"
            element={
              isAuthenticated() ? (
                <AdminLayout />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />

            {/* 🔹 Chỉ hiển thị nếu có quyền */}
            {hasPermission("POST_SHOW") && (
              <Route path="posts" element={<Posts />} />
            )}
            {hasPermission("USER_SHOW") && (
              <Route path="users" element={<Users />} />
            )}
            {hasPermission("MEMBERSHIP_FEE_SHOWS") && (
              <Route path="membershipfees" element={<MembershipFees />} />
            )}
            {/* {hasPermission("PARTNER_SHOW") && ( */}
            {hasPermission("COMPANY_SHOW") && (
              <Route path="partner" element={<Partners />} />
            )}
            {/* )} */}
            {hasPermission("ROLE_SHOW") && (
              <Route path="roles" element={<Roles />} />
            )}
            <Route path="media" element={<Medias />} />
            {hasPermission("MEDIA_UPDATE") && (
              <Route path="settings" element={<SystemSettings />} />
            )}
            {hasPermission("SPONSOR_SHOW") && (
              <Route path="sponsors" element={<AdminSponsors />} />
            )}
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="videos" element={<Video />} />
            <Route path="category" element={<Category />} />
            <Route path="permission-show" element={<PermissionCategoty />} />
            <Route path="product" element={<Products />} />
            <Route path="order" element={<Orders />} />
            {hasPermission("COUPON_SHOW") && (
              <Route path="coupon" element={<Coupons />} />
            )}
            {hasPermission("POST_SHOW") && (
              <Route path="notification" element={<Notification />} />
            )}
            <Route path="order-history" element={<OrdersHistory />} />
            {hasPermission("CRITERIA_SHOW") && (
              <Route path="criteria" element={<Criteria />} />
            )}
            {hasPermission("REGISTER_SHOW") && (
              <Route path="registration" element={<Registration />} />
            )}
            {hasPermission("COMMENT_SHOW") && (
              <Route path="feedback" element={<Feedback />} />
            )}
            {hasPermission("POINT_LOGS") && (
              <Route path="point-log" element={<PointLog />} />
            )}
            {hasPermission("CONTACT_SHOW") && (
              <Route path="contact" element={<AdminContact />} />
            )}
            {hasPermission("AUDIT_LOG_SHOW") && (
              <Route path="audit-logs" element={<AuditLogs />} />
            )}
          </Route>
          <Route path="/ban-dieu-hanh" element={<Login />} />

          <Route path="*" element={<NotFound />} />
          <Route path="/hoat-dong/cong-dong" element={<UnderConstruction />} />
          {/* <Route path="/hoat-dong/tu-thien" element={<UnderConstruction />} /> */}
          <Route path="/tin-bao-chi" element={<UnderConstruction />} />
          <Route path="/van-ban" element={<UnderConstruction />} />

          {/* <Route path="/admin/roles" element={<UnderConstruction />} /> */}
          <Route
            path="/tin-tuc-su-kien/tin-moi"
            element={<UnderConstruction />}
          />
          <Route
            path="/tin-tuc-su-kien/su-kien-noi-bat"
            element={<UnderConstruction />}
          />
        </Routes>
      </DataLoader>
      {!isAdminRoute && <ButtonCart />}
    </Router>
  );
}

export default App;

